import { Pipe, PipeTransform } from '@angular/core';
import { AccountingPlatformType } from '@app/_shared/types/accounting-platform.type';

@Pipe({
  name: 'platformToDisplayText',
  standalone: false, // eslint-disable-line
})
export class PlatformToDisplayTextPipe implements PipeTransform {
  transform(platform: AccountingPlatformType): any {
    switch (platform) {
      case 'billy': {
        return 'Billy';
      }
      case 'dinero': {
        return 'Dinero';
      }
      case 'economic': {
        return 'e-conomic';
      }
      case 'uniconta': {
        return 'Uniconta';
      }
      case 'zenegy': {
        return 'Zenegy';
      }
      default: {
        return '';
      }
    }
  }
}
